import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Typography
} from '@mui/material';
import { toast } from 'react-toastify';
import { ArrowBack } from '@mui/icons-material';

function EditAnnouncementPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isActive, setIsActive] = useState(true);

  const toDateTimeLocal = (value) => {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const shifted = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return shifted.toISOString().slice(0, 16);
  };

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const res = await api.get(`/announcements/${id}`);
        const data = res.data;
        setTitle(data.title);
        setMessage(data.message || '');
        setStartDate(toDateTimeLocal(data.start_date));
        setEndDate(toDateTimeLocal(data.end_date));
        setIsActive(data.is_active);
      } catch (error) {
        console.error(error);
        toast.error('Failed to load announcement details.');
      }
    };

    fetchAnnouncement();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/admin/announcements/${id}`, {
        title,
        message,
        start_date: startDate,
        end_date: endDate || null,
        is_active: isActive,
      });
      toast.success('Announcement updated successfully!');
      navigate('/admin/announcements');
    } catch (error) {
      console.error(error);
      toast.error('Failed to update announcement.');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: 'auto', mt: 3 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2
              }}
            >
      <Typography variant="h5" gutterBottom>
        Edit Announcement
      </Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBack/>}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
        </Box>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Title"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          required
          sx={{ mb: 2 }}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <TextField
          label="Start Date"
          type="datetime-local"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <TextField
          label="End Date"
          type="datetime-local"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label="Active"
        />

        <Button variant="contained" color="primary" type="submit" sx={{ mt: 2 }}>
          Update Announcement
        </Button>
      </form>
    </Box>
  );
}

export default EditAnnouncementPage;
